import React from 'react';

export default function Quote() {
  return (
    <>
      <blockquote cite="https://www.prodigygame.com/main-en/blog/math-quotes/">
        <h2 style={{
          width: '54rem', margin: '0 auto', color: '#00c2cb', fontFamily: 'Poppins',
        }}
        >
          Mathematics is not about numbers, Equations, computations, or algorithims:
          its about understanding
        </h2>
      </blockquote>
      <h3 style={{ width: '54rem', margin: '0 auto', fontFamily: 'Poppins' }}>
        <strong>William Paul Thompson</strong>
      </h3>
    </>
  );
}
